/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/details-disclosure.js":
/*!****************************************************!*\
  !*** ./src/scripts/sections/details-disclosure.js ***!
  \****************************************************/
/***/ (() => {

eval("class DetailsDisclosure extends HTMLElement {\n  constructor() {\n    super();\n    this.mainDetailsToggle = this.querySelector('details');\n    this.addEventListener('keyup', this.onKeyUp);\n    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));\n  }\n\n  onKeyUp(event) {\n    if (event.code.toUpperCase() !== 'ESCAPE') return;\n    const openDetailsElement = event.target.closest('details[open]');\n    if (!openDetailsElement) return;\n    const summaryElement = openDetailsElement.querySelector('summary');\n    openDetailsElement.removeAttribute('open');\n    summaryElement.focus();\n  }\n\n  onFocusOut() {\n    setTimeout(() => {\n      if (!this.contains(document.activeElement)) this.close();\n    });\n  }\n\n  close() {\n    this.mainDetailsToggle.removeAttribute('open');\n  }\n\n}\n\ncustomElements.define('details-disclosure', DetailsDisclosure);\n\n//# sourceURL=webpack://fyidoctors_shopify_theme/./src/scripts/sections/details-disclosure.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/scripts/sections/details-disclosure.js"]();
/******/ 	
/******/ })()
;